import { render } from "./EditUserForm.vue?vue&type=template&id=7fc0129c"
import script from "./EditUserForm.vue?vue&type=script&lang=js"
export * from "./EditUserForm.vue?vue&type=script&lang=js"
script.render = render

export default script